document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.custom-carousel');
  if (!carousel) return;

  const inner = carousel.querySelector('.carousel-inner');
  const items = carousel.querySelectorAll('.carousel-item');
  const prevBtn = carousel.querySelector('.carousel-control.prev');
  const nextBtn = carousel.querySelector('.carousel-control.next');
  const indicators = carousel.querySelectorAll('.indicator');
  
  let currentIndex = 0;
  const itemCount = items.length;
  let autoPlayInterval;
  
  function goToSlide(index) {
    currentIndex = (index + itemCount) % itemCount;
    updateCarousel();
  }
  
  function updateCarousel() {
    inner.style.transform = `translateX(-${currentIndex * 100}%)`;
    
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentIndex);
    });
  }
  
  function startAutoPlay() {
    autoPlayInterval = setInterval(() => {
      goToSlide(currentIndex + 1);
    }, 5000);
  }
  
  function stopAutoPlay() {
    clearInterval(autoPlayInterval);
  }
  
  // Event listeners
  nextBtn.addEventListener('click', () => {
    goToSlide(currentIndex + 1);
    stopAutoPlay();
    startAutoPlay();
  });
  
  prevBtn.addEventListener('click', () => {
    goToSlide(currentIndex - 1);
    stopAutoPlay();
    startAutoPlay();
  });
  
  indicators.forEach(indicator => {
    indicator.addEventListener('click', () => {
      const slideIndex = parseInt(indicator.getAttribute('data-index'));
      goToSlide(slideIndex);
      stopAutoPlay();
      startAutoPlay();
    });
  });
  
  // Pause on hover
  carousel.addEventListener('mouseenter', stopAutoPlay);
  carousel.addEventListener('mouseleave', startAutoPlay);
  
  // Initialize
  updateCarousel();
  startAutoPlay();
});